import { API } from "./api";
import { TransportOptions, Response, Transport, Event } from "@jupiter/types";
import { JupiterError } from "@jupiter/utils";

/** Base Transport class implementation */
export abstract class BaseTransport implements Transport {
  protected readonly _api: API;

  public constructor(public options: TransportOptions) {
    this._api = new API(options.endpoint);
  }

  /**
   * @inheritDoc
   */
  public sendEvent(_: Event): PromiseLike<Response> {
    throw new JupiterError(
      "Transport Class has to implement `sendEvent` method"
    );
  }
}
